function Authorize() {
    this.ajax = new Ajax();
}
Authorize.prototype.initAll = function() {
    this.initLogin();
    this.initLogout();
}
Authorize.prototype.initLogin = function() {
    var self = this;
    $(".nt-header-top-account .wrap-login input").click(function(e) {
        var form = $(this).closest('form');
        ajaxLogin(form);
        e.preventDefault();
    });

    function ajaxLogin(form) {
        $.ajax({
            type: "post",
            url: "/account/login",
            data: form.serialize(),
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(data) {
                var href = $(data).find('.header-top-link .nt-header-top-account > a').attr('href');
                if (href === '/account/logout') {
                    self.ajax.filterAjaxClick(null, self.renderPage, function() {
                        toastr.success('You have successfully logged in!');
                        var app = new App();
                        app.init();
                        Ajax.hideLoading();
                    });
                } else {
                    toastr.error('Can&#39;t login!');
                    Ajax.hideLoading();
                }
            },
            error: function(xhr, text) {
                toastr.error('You have successfully logged in!');
                Ajax.hideLoading();
            }
        });
    };
}
Authorize.prototype.initLogout = function() {
    var self = this;
    $(".nt-header-top-account #customer_login_out").click(function(e) {
        ajaxLogout();
        e.preventDefault();
    });

    function ajaxLogout() {
        $.ajax({
            type: "get",
            url: "/account/logout",
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function() {
                self.ajax.filterAjaxClick(null, self.renderPage, function() {
                    toastr.success('You have successfully logged out!');
                    var app = new App();
                    app.init();
                    Ajax.hideLoading();
                });
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t logout!');
                Ajax.hideLoading();
            }
        });
    };
}
Authorize.prototype.renderPage = function(data, callback) {
    var currentHeader = $("header.site-header");
    var newHeader = $(data).find("header.site-header");
    currentHeader.replaceWith(newHeader);
    var currentContent = $("main.main-content");
    var newContent = $(data).find("main.main-content");
    currentContent.replaceWith(newContent);
    var imageShopify = new ImageShopify();
    imageShopify.initImageConfigure();
    imageShopify.initSetProductHeight();
    if (callback) {
        callback();
    }
}
